import { render, staticRenderFns } from "./ListSummary.vue?vue&type=template&id=4fc706e9&scoped=true&"
import script from "./ListSummary.vue?vue&type=script&lang=js&"
export * from "./ListSummary.vue?vue&type=script&lang=js&"
import style0 from "./ListSummary.vue?vue&type=style&index=0&id=4fc706e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc706e9",
  null
  
)

export default component.exports